<template>
  <div class="dropdown single-filter">
    <a href="#_-_" 
      :id="dropDownMenuId" 
      type="button" 
      class="dropdown-toggle skip-gtm-event"
      data-toggle="dropdown">
        <div :class="{'active': childSelected }">
          <i v-if="mainIcon.length > 0" :class="mainIcon"></i><span v-html="message"></span>&nbsp;<span v-if="count > 0">({{ count }})</span>
        </div>
        <i class="fa fa-chevron-down"></i>
    </a>
    <div 
      class="dropdown-menu sottomenu"
      v-bind:aria-labelledby="dropDownMenuId">
      <div class="title-mobile">
        <div>
          <i :class="mainIcon"></i> {{ mainMessage }}
          <div class="close"><i class="fas fa-times"></i></div>
        </div>
        <div>{{ mobileMessage }}</div>
      </div>
      <drop-down-option  
        v-for="category in categories" 
        v-bind:key="category.term_id"
        v-bind:category="category">
      </drop-down-option>
    </div>
  </div>
</template>

<script>
import DropDownOption from './DropDownOption.vue';
import he from 'he';

export default {
  name: 'DropDown',
  components: {
    'drop-down-option': DropDownOption
  },
  props: {
    mainIcon: String,
    mainMessage: String,
    mobileMessage: String,
    categoryName: String,
    pluralCategoryName: String,
    pluralFilter: String,
    multiple: Boolean,
    inputArray: Boolean
  },
  created: function() {
    this.$root.$on('categories-loaded', function(data){
      this.categories = data[this.categoryName];
    }.bind(this));
  },
  mounted: function() {
    function disableScroll(){
      document.body.addEventListener(
        'touchmove',
        function(e) {
          return e.stopPropagation();
        },
        { passive: false }
      );
    }

    function enableScroll(){
      document.body.removeEventListener(
        'touchmove',
        function(e) {
          return e.stopPropagation();
        }
      );
    }

    // eslint-disable-next-line
    jQuery(this.$el).on(
      'show.bs.dropdown',
      function() {
        let scrollTop = jQuery('html').scrollTop() + 120;
        if ( jQuery(window).width() < 992 ) {
          // eslint-disable-next-line
          jQuery('body').addClass('modal-open');
          jQuery('html').stop().animate({
            'scrollTop': scrollTop
          }, 
          { complete: disableScroll }
          );
        }
      }
    );
    // eslint-disable-next-line
    jQuery(this.$el).on(
      'hide.bs.dropdown',
      function() {
        let scrollTop = jQuery('html').scrollTop() - 120;
        if ( jQuery(window).width() < 992 ) {
          // eslint-disable-next-line
          jQuery('body').removeClass('modal-open');
          jQuery('html').stop().animate({
            'scrollTop': scrollTop
          }, 
          { complete: enableScroll }
          );
        }
      }
    );
  },
  data: function() {
    return {
      categories: [],
      message: this.mainMessage,
      childSelected: false,
      count: 0,
    };
  },
  computed: {
    dropDownMenuId: function() {
      return 'menu-' + this.categoryName.toLowerCase();
    }
  },
  methods: {
    fullSelectionMessage: function() {
      let fullSelectionMessage = '';
      let count = 0;
      let message = [];
      let child;
      let selected = 0;

      for( let i in this.$children ) {
        child = this.$children[i];

        if ( child.isActive ) {
          message.push( he.decode( child.category.name ) );
          selected += 1;
          count += child.category.count;
        }
      }

      if ( selected > 1 ) {
        fullSelectionMessage = [
          selected,
          he.decode( this.pluralCategoryName.toLowerCase() ),
          ( 0 === this.pluralFilter.length ) ? 'filtrati' : this.pluralFilter,
          he.decode( '&hellip;' ),
        ].join(' ');
      }
      else {
        fullSelectionMessage = message.join(', ');
      }

      if ( this.isEmpty() ) {
        this.count = 0;
      }
      else {
        this.count = this.$parent.result;
      }
      return fullSelectionMessage;
    },
    changeMessage: function() {
      let fullSelectionMessage = this.fullSelectionMessage();
      this.message = this.mainMessage;

      if ( fullSelectionMessage.length > 0 ) {
        this.message = fullSelectionMessage;
        this.childSelected = true;
      }
      else {
        this.childSelected = false;
      }
    },
    isEmpty: function() {
      let empty = true;
      let children = this.$children;
      let child;
      let i = 0;

      for ( i = 0; i < children.length; i++ ) {
        child = children[i];
        if ( child.isActive ) {
          empty = false;
        }
      }

      return empty;
    },
    emptyChildren: function( filter ) {
      let children = this.$children;
      let child;
      let i = 0;

      for ( i = 0; i < children.length; i++ ) {
        child = children[i];
        if ( child.isActive && child.categoryId != filter.categoryId ) {
          child.changeActive();
          child.changeDisabled();
          child.removeFromStorage();
        }
      }
    }
  }
}
</script>